// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6b4d38cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./volumeTemplates.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("00620fb3", content, false);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6b4d38cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./volumeTemplates.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6b4d38cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./volumeTemplates.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6b4d38cb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/trade/shipping/templates/volumeTemplates.vue
// module id = 3410
// module chunks = 0